import { DocumentationPageContentItem } from "@supernova-studio/model";
import { z } from "zod";

export const DocumentationPageEditorModel = z.object({
  blocks: z.array(DocumentationPageContentItem),
});

export type DocumentationPageEditorModel = z.infer<typeof DocumentationPageEditorModel>;
